var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rd-text',{attrs:{"usebyTable":false}},[_vm._v(_vm._s(_vm.row.nickname))])
}
var staticRenderFns = []

export { render, staticRenderFns }